// EventType values, hand-synched w/ PortCall.Models\Events\Event.cs.
export enum EventType {
    Comment                         = "CO00",
    GeoActivity                     = "GA00",
    PortCallChange                  = "PC00",
    PortCallDeletion                = "PC01",
    TopicCardChange                 = "TC00",
    RecurringBatchChange            = "RB00",
    RecurringBatchDeletion          = "RB01",
    PilotJobOrderChange             = "PJ00",
    PilotJobOrderCancellation       = "PJ01",
    PilotShiphandlingNote           = "SN00",
    VesselChange                    = "VS00",
    PortCallAgentChanged            = "PCAG",
    PortCallVesselChanged           = "PCVS",
    PortCallFirstReminderReady      = "PCR1",
    PortCallFinalReminderReady      = "PCR2",
    IPLocationChanged               = "IPLC",
    IPArrivalEffDateChanged         = "IPAC",
    IPDepartureEffDateChanged       = "IPDC",
    IPBothEffDatesChanged           = "IPBC",
    IPArrivalLogged                 = "IPAL",
    IPDepartureLogged               = "IPDL",
    IPArrivalUnlogged               = "IPAU",
    IPDepartureUnlogged             = "IPDU",
    ReservationFootmarkChanged      = "BRFM",
    ReservationStatusChanged        = "BRST",
    ReservationConflictCountChanged = "BRCC",
    ReservationSideToChanged        = "BRSI",
    BatchBooked                     = "RBBO",
    BatchUnbooked                   = "RBUN",
    BatchCancelled                  = "RBCN",
    CCardRequested                  = "CCRQ",
    CCardCancelled                  = "CCCN",
    CCardStatusUpdate               = "CCST",
    CCardProviderChanged            = "CCPR",
    PJOEstDateChanged               = "PJED",
    PJOActualDateChanged            = "PJAD",
    PJOTugCompanyChangedEvent       = "PJTU",
    PJOLineHandlerChangedEvent      = "PJLH",
    PJOLaborStartChangedEvent       = "PJLA",
    PJOAirDraftChangedEvent         = "PJAD",
    PJODeepDraftChangedEvent        = "PJDD",
    PJOBowThrusterChangedEvent      = "PJBT",
}



// WEBPACK FOOTER //
// ./data/models/EventType.ts